import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Login from './Login';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AvtHome from './AvtHome';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>  
      
    { <Login/> 
     /* <AvtHome/>03-02-2026*/}
  </React.StrictMode>
);



reportWebVitals();


